// --------------------------------------------------------
// LabelInput - LabelInput
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import { InputAdornment, TextField } from "@mui/material";
import useResponsiveInfo from "../../hooks/useResponsiveInfo";

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// LabelInput INTERFACE
// --------------------------------------------------------

interface ILabelInput {
  leftIcon?: any;
  rightIcon?: any;
  placeholder?: any;
  label?: any;
  style?: any;
  isInputError?: boolean;
  inputErrorText?: any;
  disabled?: boolean;
  fullWidth?: boolean;
  type?: string;
  value: any;
  onChangeText: React.ChangeEventHandler<
    HTMLTextAreaElement | HTMLInputElement
  >;
  onKeyDown?: React.KeyboardEventHandler<any>;
}

/**
/**
 * A component that renders a input field with a label and placeholders.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const LabelInput = ({
  value,
  leftIcon,
  rightIcon,
  placeholder = "",
  label = "",
  style,
  isInputError,
  inputErrorText,
  disabled,
  fullWidth,
  type = "text",
  onChangeText,
  onKeyDown,
}: ILabelInput) => {
  // --------------------------------------------------------
  // LabelInput PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const { isMobile } = useResponsiveInfo();

  const LeftIcon = () => {
    return <InputAdornment position="start">{leftIcon}</InputAdornment>;
  };

  const RightIcon = () => {
    return <InputAdornment position="end">{rightIcon}</InputAdornment>;
  };

  // --------------------------------------------------------

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
      <TextField
        id="standard-basic"
        variant="standard"
        value={value}
        type={type}
        onChange={onChangeText}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        label={label}
        error={isInputError}
        disabled={disabled}
        helperText={isInputError ? inputErrorText : ""}
        InputProps={{
          endAdornment: <RightIcon />,
          startAdornment: <LeftIcon />,
        }}
        sx={[
          style,
          {
            width: fullWidth ? "100%" : (isMobile ? "95%" : "49%"),
            alignSelf: (fullWidth || !isMobile) ? "" : "center",
          },
        ]}
      />
    </>
  );
  // --------------------------------------------------------
};

export default LabelInput;
